<template>
  <div class="Vuecontainer">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>